import { render, staticRenderFns } from "./RiskUploadDialog.vue?vue&type=template&id=56490984"
import script from "./RiskUploadDialog.vue?vue&type=script&lang=js"
export * from "./RiskUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports